"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "graniti": {
    "ce49dd3e": [{
      "hkey": "9481ed16",
      "slug": "musciano-cupparo",
      "name": "Muscianò-Cupparo",
      "primary": true,
      "skipSearch": false
    }],
    "musciano": [{
      "hkey": "9481ed16",
      "slug": "musciano-cupparo",
      "name": "Muscianò-Cupparo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e094ba30": [{
      "hkey": "c436ceed",
      "slug": "graniti",
      "name": "Graniti",
      "primary": true,
      "skipSearch": false
    }],
    "postoleone": [{
      "hkey": "c436ceed",
      "slug": "graniti",
      "name": "Graniti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;